export enum Postplay {
  CONTINUE_PLAY = "CONTINUE_PLAY",
  AUTO_PLAY = "AUTO_PLAY",
  NONE = "NONE"
}
